import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    beingDeletedItemIds: [],
};
const locationSlice = createSlice({
    name: 'locations',
    initialState,
    reducers: {
        addItemToBeingDeleted: (state, action) => {
            state.beingDeletedItemIds.push(action.payload);
        },
        removeItemFromBeingDeleted: (state, action) => {
            state.beingDeletedItemIds = state.beingDeletedItemIds.filter((item) => item !== action.payload);
        },
    },
});
export const { actions: locationActions, reducer: locationStateReducer } = locationSlice;
